import { RosaAuthService, RosaCoreLocalStorageKey } from '@/rosa';
import { inject } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

export const isNotAuthenticatedGuard: CanActivateFn & CanActivateChildFn = async () => {
    const _rosaAuthService = inject(RosaAuthService);
    const _router = inject(Router);

    const isAuthenticated = await firstValueFrom(_rosaAuthService.isAuthenticated$());

    if (isAuthenticated || localStorage.getItem(RosaCoreLocalStorageKey.CONNECTED_AS_EMAIL)) {
        _router.navigate(['/', 'homepage']);
        return false;
    }

    return true;
};
